var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "app-side-menu",
    { attrs: { "min-width": 18, "fixed-menu": false } },
    [
      _c(
        "aside",
        {
          staticClass: "menu",
          attrs: { slot: "side-menu" },
          slot: "side-menu",
        },
        [
          _c("p", { staticClass: "menu-label" }, [
            _c("span", { staticClass: "title is-6" }, [
              _vm._v(" " + _vm._s(_vm.entityName) + " "),
            ]),
          ]),
          _c("ul", { staticClass: "menu-list" }, [
            _c(
              "li",
              [
                _c(
                  "router-link",
                  {
                    attrs: {
                      to: {
                        name: _vm.routeTypes.UnscheduledModelDetail.name,
                        query: _vm.$route.query,
                      },
                      "active-class": "is-active",
                      exact: "",
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        class: {
                          "has-badge-danger has-badge-small has-badge-rounded has-badge-offset2":
                            _vm.$v.detailGroup.$error,
                        },
                        attrs: {
                          "data-badge": _vm.$v.detailGroup.$error ? "" : null,
                        },
                      },
                      [_vm._v(" Detail Info ")]
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }